export interface IMarketCategory {
    category_id: string;
    category_name: string;
    category_logo?: string;

    from_category_id?: string; // 上级分类id
    enterprise_id?: string;
    category_type?: string;
    sort?: string;
    is_del?: string;
    created_at?: string;
    updated_at?: string;
}

export enum ListType {
    COURSE = '0',
    CIRCLE = '1',
}
